import { jsx as t, jsxs as u } from "react/jsx-runtime";
import * as A from "react";
import { useMultiStyleConfig as E, chakra as h } from "@chakra-ui/react";
import { AvatarStylesProvider as x } from "./Avatar.context.es.js";
import { AvatarEdit as y } from "./components/AvatarEdit.es.js";
import { AvatarIcon as _ } from "./components/AvatarIcon.es.js";
import { AvatarImage as g } from "./components/AvatarImage.es.js";
import "../../icons/index.es.js";
const M = A.forwardRef(
  ({ __css: a, boxSize: e, src: m, name: c, alt: d, size: s = "md", trackId: r, variant: f, ...o }, v) => {
    const n = E("AvatarTheme", { size: s, variant: f }), i = "onEdit" in o, l = "icon" in o;
    return /* @__PURE__ */ t(x, { value: n, children: /* @__PURE__ */ u(
      h.div,
      {
        __css: { ...n.root, __css: a },
        onClick: i ? o.onEdit : void 0,
        "track-id": r,
        _hover: {
          cursor: i ? "pointer" : "default"
        },
        ref: v,
        ...o,
        children: [
          /* @__PURE__ */ t(g, { boxSize: e, src: m, name: c, alt: d, trackId: r }),
          i && /* @__PURE__ */ t(y, { onEdit: o.onEdit }),
          l && /* @__PURE__ */ t(_, { icon: o.icon })
        ]
      }
    ) });
  }
);
export {
  M as Avatar
};
//# sourceMappingURL=Avatar.es.js.map
